import { PageBlockTypes as p } from '@xprog/prensa/types'

export const TemplateSideBoxFixed: p.PageBlockProps = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      mt: '$6',
      '@lg': {
        pb: '$0',
        px: '$0',
        mt: '$6',
        mb: '$8',
        position: 'sticky',
        top: '200px'
      },
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ExtraTop .ColumnContent': {
        align: ['row', 'left', 'bottom'],
        mb: '0px',
        width: '100%',
        '.pds-Button-root': {
          backgroundColor: '#FFFFFF',
        }
      },
      '.Center .ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$2',
        backgroundColor: '#FFFFFF',
        border: '1px solid #E6E6E6',
        borderTop: 'unset',
        borderBottomLeftRadius: '$alternative',
        borderBottomRightRadius: '$alternative',
        overflow: 'hidden',
        py: '$0',
        width: '100%',
      }
    }
  }
}